import { Component, OnInit } from '@angular/core';
import { SharedModule } from "../../../shared/shared.module";
import { DataColumn } from "../../../models";
import { MissionService } from "../../../services/mission.service";
import { Router } from "@angular/router";
import { EstablishmentService } from "../../../services/establishment.service";
import {
  AgencyMoreDetailActionForCandidateComponent
} from "../agency-candidates/agency-more-detail-action-for-candidate/agency-more-detail-action-for-candidate.component";
import {
  AgencyMoreDetailActionForEtbComponent
} from "./agency-more-detail-action-for-etb/agency-more-detail-action-for-etb.component";
import { NgxIntlTelInputModule } from "@justin-s/ngx-intl-tel-input";
import { SvgIconComponent } from "angular-svg-icon";
import { EtablissementComponent } from '../../etablissement/etablissement.component';
import { MatDialog } from '@angular/material/dialog';
import { AddEstablishmentDialogComponent } from './add-establishment-dialog/add-establishment-dialog.component';
// Add import at the top
import { AgencyEditActionForEtbComponent } from "./agency-edit-action-for-etb/agency-edit-action-for-etb.component";

@Component({
  selector: 'app-agency-establishment',
  standalone: true,
  imports: [
    SharedModule,
    NgxIntlTelInputModule,
    SvgIconComponent
  ],
  templateUrl: './agency-establishment.component.html',
  styleUrl: './agency-establishment.component.scss'
})
export class AgencyEstablishmentComponent implements OnInit {

  size = 10;
  offset = 0;
  totalItems = 0;
  isLoading: boolean = false;
  searchKeyword: string = '';
  // Update the customColumns array to include the edit action
  customColumns: DataColumn[] = [
    {
      header: 'Nom',
      fieldName: 'name',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Numéro SIRET',
      fieldName: 'siret',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Type d\'établissement',
      fieldName: 'type',
      dataType: 'string',
      col: 'col',
    },
    // {
    //   header: 'Adresse du siège social',
    //   fieldName: 'address',
    //   dataType: 'string',
    //   col: 'col',
    // },
    // {
    //   header: 'Noms des sites',
    //   fieldName: 'sites',
    //   dataType: 'string',
    //   col: 'col',
    // },
    {
      header: 'Code postal',
      fieldName: 'codePostal',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Ville',
      fieldName: 'sitesCity',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Actions',
      unClickable: true,
      fieldName: '',
      dataType: 'component',
      component: AgencyMoreDetailActionForEtbComponent,
    },
    {
      header: '',
      unClickable: true,
      fieldName: '',
      dataType: 'component',
      component: AgencyEditActionForEtbComponent,
    },
  ];
  etabList: any[] = [];
  etabListFiltered: any[];
  totalItemsAfterFilter: number;

  constructor(private api: EstablishmentService,
    private router: Router,
    private dialog: MatDialog) {
  }

  getSocialAddress(e: any) {
    if (!e?.adresses || e.adresses.length === 0) return null;
    return e.adresses.find((u: any) => u.issocial) || e.adresses[0];
  }

  ngOnInit(): void {
    this.loadEstablishments();
  }

  loadEstablishments(): void {
    this.isLoading = true;
    this.api.getAgencyEstablishmentsWithPagination(this.offset, this.size, this.searchKeyword).subscribe({
      next: (response: any) => {
        this.etabListFiltered = response.data.map((e: any) => {
          return {
            id: e.id,
            name: e.name,
            siret: e.numsiret,
            type: e.typeetablissement,
            address: '',
            sites: '',
            codePostal: e.codePostal,
            sitesCity: e.ville,
          }
        });
        this.totalItems = response.total;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading establishments:', err);
        this.etabListFiltered = [];
        this.totalItems = 0;
        this.isLoading = false;
      }
    });
  }

  handleRowClick(evt: any) {
    this.router.navigate([`/agency/details-establishment/${evt.id}`])
  }

  pagination($event: any) {
    // Backend uses PageRequest.of(offset, size) → offset is the 0-based PAGE index, not a row offset.
    this.offset = $event.pageIndex;
    this.loadEstablishments();
  }

  searchItem(event: any) {
    this.offset = 0; // Reset to first page on search
    if (event) {
      this.searchKeyword = event.target.value.trim().toLowerCase();
    } else {
      this.searchKeyword = '';
    }
    this.loadEstablishments();
  }

   openAddEtablissementDialog(): void {
    this.dialog.open(AddEstablishmentDialogComponent, {
      width: '700px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result && result.refresh) {
        this.ngOnInit();
        if (result.establishmentId) {
          this.router.navigate([`/agency/establishment/edit/${result.establishmentId}`]);
        }
      }
    });
   }

}
